import { render, staticRenderFns } from "./guanyuwomen.vue?vue&type=template&id=00c5188d&scoped=true&"
import script from "./guanyuwomen.vue?vue&type=script&lang=js&"
export * from "./guanyuwomen.vue?vue&type=script&lang=js&"
import style0 from "./guanyuwomen.vue?vue&type=style&index=0&id=00c5188d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c5188d",
  null
  
)

export default component.exports